/* eslint-disable no-undef */
/**
 * Things here are injected implicitly by webpack.DefinePlugin()
 */
let REV = defineREV;

export { REV };
